// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2pVX3","error":"Textarea_error__3AzLD","readonly":"Textarea_readonly__Fo8tD","disabled":"Textarea_disabled__1d5aL"};